import { render, staticRenderFns } from "./AppointPage.vue?vue&type=template&id=ff00a380&scoped=true&"
import script from "./AppointPage.vue?vue&type=script&lang=js&"
export * from "./AppointPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff00a380",
  null
  
)

export default component.exports